import { CareerStudioApp } from "./components/CareerStudioApp";

export default function App() {
  return <CareerStudioApp />;
}
